import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'footer',
    templateUrl: './footer.html',
    imports: [
        TranslatePipe,
        AsyncPipe,
    ]
})
export class FooterComponent {

    currYear: number = new Date().getFullYear();
    user$: Observable<any>;
    constructor(public translate: TranslateService, public storeData: Store<any>) {
        this.user$ = this.storeData.select((state: any) => state.auth?.user);
    }
    ngOnInit() {}

    openPrivacyPolicy() {
        window.open('https://suknacapital.com/privacy-policy', '_blank');
    }

    openDisclosures() {
        window.open('https://suknacapital.com/disclosures', '_blank');
    }

    openContactUs() {
        window.open('https://suknacapital.com/contact-us', '_blank');
    }
}
